module.exports = __webpack_public_path__ + "img/CF_2X.5e367ad9.jpg";